import { diffIn, fromNow, formatDate } from '../../utils/dateHelpers'
import { TIME_FORMAT } from './constants'

export function formatReadableDate(date: Date) {
  if (diffIn(new Date(), date, 'hours') < 10) {
    return fromNow(date)
  }
  return formatDate(date, TIME_FORMAT)
}
